import { AfterViewInit, Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { Router } from '@angular/router';
import * as AOS from 'aos';

import { SeoService } from '../Services/seo.service';
import { seoContent } from '../Services/seoContent';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements AfterViewInit {
  @ViewChild('DefaultHomeModalTrigger') DefaultHomeModalTrigger: ElementRef;
  @ViewChild('DefaultHomeDisclaimerModal') modalClose: ElementRef;

  localBusinessDataHTML: SafeHtml;
  logoDataHTML: SafeHtml;
  breadCrumbDataHTML: SafeHtml;

  @ViewChild('capabilities') capabilitiesElement: ElementRef<any>;
  @ViewChild('Operating') OperatingElement: ElementRef<any>;
  @ViewChild('transformation') transformationElement: ElementRef<any>;
  @ViewChild('next') nextElement: ElementRef<any>;
  @ViewChild('service') serviceElement: ElementRef<any>;
  @ViewChild('About') aboutElement: ElementRef<any>;
  @ViewChild('spsoft') spSoftElement: ElementRef<any>;
  @ViewChild('Careers') careersElement: ElementRef<any>;

  currentMenuId = 'menu1';
  currentActive = 1;
  capabilitiesOffset = 0;
  OperatingOffset = 0;
  transformationOffset = 0;
  nextOffset = 0;
  serviceOffset = 0;
  AboutOffset = 0;
  spSoftOffset = 0;
  CareersOffset = 0;
  projectCount = 0;
  accurateCount = 0;
  clientCount = 0;
  customerFeedback = 0;
  countries = 0;

  capabilitiesMenu = 'Digital Partner';
  OperatingMenu = 'Core Capabilities';
  transformationMenu = 'Digital Operating';
  nextMenu = 'Industries';
  serviceMenu = 'Services'
  AboutMenu = 'Workforce Solutions';
  spSoftMenu = 'Why SPSoft';
  CareersMenu = 'Careers';

  projectCountStop: any = setInterval(() => {
    this.projectCount++;
    if (this.projectCount === 29) {
      clearInterval(this.projectCountStop);
    }
  }, 50);

  accurateCountStop: any = setInterval(() => {
    this.accurateCount++;
    if (this.accurateCount === 100) {
      clearInterval(this.accurateCountStop);
    }
  }, 60);

  clientCountStop: any = setInterval(() => {
    this.clientCount++;
    if (this.clientCount === 650) {
      clearInterval(this.clientCountStop);
    }
  }, 55);

  customerFeedbackStop: any = setInterval(() => {
    this.customerFeedback++;
    if (this.customerFeedback === 500) {
      clearInterval(this.customerFeedbackStop);
    }
  }, 80);

  countriesCount: any = setInterval(() => {
    this.countries++;
    if (this.countries === 6) {
      clearInterval(this.countriesCount);
    }
  }, 6800);

  /**
   * Creates an instance of HomeComponent.
   * @param {SeoService} seoService
   * @param {Router} route
   */
  constructor(
    private seoService: SeoService,
    private route: Router
  ) { }

  /**
   * Life Cycle Hook Initialization
   */
  ngOnInit() {
    this.seoService.addTitleAndTags(seoContent.main.url, seoContent.main.title, seoContent.main.description);
    this.localBusinessDataHTML = this.seoService.addLocalBusinessStructureData();
    const servicesData = this.seoService.addStructuredData(seoContent.main.url, "Home");
    this.logoDataHTML = servicesData.logoData;
    this.breadCrumbDataHTML = servicesData.breadData;
  }

  /**
   * ng After View init
   */
  ngAfterViewInit() {

    if (this.route.url === '/') {
      this.DefaultHomeModalTrigger.nativeElement.click();
      setTimeout(() => {
        this.modalClose.nativeElement.click();
      }, 10000);
    }
    this.updateOffsets();
    window.addEventListener('resize', this.updateOffsets.bind(this));
    AOS.init();
  }


  updateOffsets() {
    this.capabilitiesOffset = this.capabilitiesElement.nativeElement.offsetTop;
    this.OperatingOffset = this.OperatingElement.nativeElement.offsetTop;
    this.transformationOffset = this.transformationElement.nativeElement.offsetTop;
    this.nextOffset = this.nextElement.nativeElement.offsetTop;
    this.serviceOffset = this.serviceElement.nativeElement.offsetTop;
    this.AboutOffset = this.aboutElement.nativeElement.offsetTop;
    this.spSoftOffset = this.spSoftElement.nativeElement.offsetTop;
    this.CareersOffset = this.careersElement.nativeElement.offsetTop;
  }


  scrollToElement() {
    // scrollToElement Code :)
  }

  @HostListener('window:scroll', ['$event'])
  checkOffsetTop() {

    this.updateOffsets();


    if (window.scrollY >= this.capabilitiesOffset && window.scrollY < this.OperatingOffset) {
      this.currentActive = 1;
      this.capabilitiesMenu = 'Digital Partner';
      this.OperatingMenu = 'Core Capabilities';
      this.transformationMenu = 'Digital Operating';
      this.nextMenu = 'Industries';
      this.serviceMenu = 'Services';
      this.AboutMenu = 'Workforce Solutions';
      this.spSoftMenu = 'Why SPSoft';
      this.CareersMenu = 'Careers';
    } else if (window.scrollY >= this.OperatingOffset && window.scrollY < this.transformationOffset) {
      this.currentActive = 2;
      this.capabilitiesMenu = 'Digital Partner';
      this.OperatingMenu = 'Core Capabilities';
      this.transformationMenu = 'Digital Operating';
      this.nextMenu = 'Industries';
      this.serviceMenu = 'Services';
      this.AboutMenu = 'Workforce Solutions';
      this.spSoftMenu = 'Why SPSoft';
      this.CareersMenu = 'Careers';
    } else if (window.scrollY >= this.transformationOffset && window.scrollY < this.nextOffset) {
      this.currentActive = 3;
      this.capabilitiesMenu = 'Digital Partner';
      this.OperatingMenu = 'Core Capabilities';
      this.transformationMenu = 'Digital Operating';
      this.nextMenu = 'Industries';
      this.serviceMenu = 'Services';
      this.AboutMenu = 'Workforce Solutions';
      this.spSoftMenu = 'Why SPSoft';
      this.CareersMenu = 'Careers';
    } else if (window.scrollY >= this.nextOffset && window.scrollY < this.serviceOffset) {
      this.currentActive = 4;
      this.capabilitiesMenu = 'Digital Partner';
      this.OperatingMenu = 'Core Capabilities';
      this.transformationMenu = 'Digital Operating';
      this.nextMenu = 'Industries';
      this.serviceMenu = 'Services';
      this.AboutMenu = 'Workforce Solutions';
      this.spSoftMenu = 'Why SPSoft';
      this.CareersMenu = 'Careers';
    }
    else if (window.scrollY >= this.serviceOffset && window.scrollY < this.AboutOffset) {
      this.currentActive = 9;
      this.capabilitiesMenu = 'Digital Partner';
      this.OperatingMenu = 'Core Capabilities';
      this.transformationMenu = 'Digital Operating';
      this.nextMenu = 'Industries';
      this.serviceMenu = 'Services';
      this.AboutMenu = 'Workforce Solutions';
      this.spSoftMenu = 'Why SPSoft';
      this.CareersMenu = 'Careers';
    } else if (window.scrollY >= this.AboutOffset && window.scrollY < this.spSoftOffset) {
      this.currentActive = 5;
      this.capabilitiesMenu = 'Digital Partner';
      this.OperatingMenu = 'Core Capabilities';
      this.transformationMenu = 'Digital Operating';
      this.nextMenu = 'Industries';
      this.serviceMenu = 'Services';
      this.AboutMenu = 'Workforce Solutions';
      this.spSoftMenu = 'Why SPSoft';
      this.CareersMenu = 'Careers';
    } else if (window.scrollY >= this.spSoftOffset && window.scrollY < this.CareersOffset) {
      this.currentActive = 6;
      this.capabilitiesMenu = 'Digital Partner';
      this.OperatingMenu = 'Core Capabilities';
      this.transformationMenu = 'Digital Operating';
      this.nextMenu = 'Industries';
      this.serviceMenu = 'Services';
      this.AboutMenu = 'Workforce Solutions';
      this.spSoftMenu = 'Why SPSoft';
      this.CareersMenu = 'Careers';
    } else if (window.scrollY >= this.CareersOffset) {
      this.currentActive = 7;
      this.capabilitiesMenu = 'Digital Partner';
      this.OperatingMenu = 'Core Capabilities';
      this.transformationMenu = 'Digital Operating';
      this.nextMenu = 'Industries';
      this.serviceMenu = 'Services';
      this.AboutMenu = 'Workforce Solutions';
      this.spSoftMenu = 'Why SPSoft';
      this.CareersMenu = 'Careers';
    } else {
      this.currentActive = 0;
      this.capabilitiesMenu = 'Digital Partner';
      this.OperatingMenu = 'Core Capabilities';
      this.transformationMenu = 'Digital Operating';
      this.nextMenu = 'Industries';
      this.serviceMenu = 'Services';
      this.AboutMenu = 'Workforce Solutions';
      this.spSoftMenu = 'Why SPSoft';
      this.CareersMenu = 'Careers';
    }

    console.log(this.currentActive, "currentActive");

  }

  public moveToCapabilitiesElement(): void {
    console.log(this.currentActive);

    const element = document.getElementById('section1');
    const bodyRect = document.body.getBoundingClientRect().top;
    const elementRect = element?.getBoundingClientRect().top || 0;
    const elementPosition = elementRect - bodyRect;
    window.scrollTo({
      top: elementPosition,
      behavior: 'smooth'
    });
  }

  public moveToOperatingElement(): void {
    console.log(this.currentActive);

    const element = document.getElementById('section2');
    const bodyRect = document.body.getBoundingClientRect().top;
    const elementRect = element?.getBoundingClientRect().top || 0;
    const elementPosition = elementRect - bodyRect;
    window.scrollTo({
      top: elementPosition,
      behavior: 'smooth'
    });
  }

  public moveToTransformationElement(): void {
    console.log(this.currentActive);

    const element = document.getElementById('section3');
    const bodyRect = document.body.getBoundingClientRect().top;
    const elementRect = element?.getBoundingClientRect().top || 0;
    const elementPosition = elementRect - bodyRect;
    window.scrollTo({
      top: elementPosition,
      behavior: 'smooth'
    });
  }

  public moveToNextElement(): void {
    console.log(this.currentActive);

    const element = document.getElementById('section4');
    const bodyRect = document.body.getBoundingClientRect().top;
    const elementRect = element?.getBoundingClientRect().top || 0;
    const elementPosition = elementRect - bodyRect;
    window.scrollTo({
      top: elementPosition,
      behavior: 'smooth'
    });
  }


  public moveToServiceElement(): void {
    console.log(this.currentActive);

    const element = document.getElementById('section9');
    const bodyRect = document.body.getBoundingClientRect().top;
    const elementRect = element?.getBoundingClientRect().top || 0;
    const elementPosition = elementRect - bodyRect;
    window.scrollTo({
      top: elementPosition,
      behavior: 'smooth'
    });
  }

  public moveToAboutElement(): void {
    console.log(this.currentActive);

    const element = document.getElementById('section5');
    const bodyRect = document.body.getBoundingClientRect().top;
    const elementRect = element?.getBoundingClientRect().top || 0;
    const elementPosition = elementRect - bodyRect;
    window.scrollTo({
      top: elementPosition,
      behavior: 'smooth'
    });
  }

  public moveToSpSoftElement(): void {
    console.log(this.currentActive);

    const element = document.getElementById('section6');
    const bodyRect = document.body.getBoundingClientRect().top;
    const elementRect = element?.getBoundingClientRect().top || 0;
    const elementPosition = elementRect - bodyRect;
    window.scrollTo({
      top: elementPosition,
      behavior: 'smooth'
    });
  }

  public moveToCareersElement(): void {
    console.log(this.currentActive);

    const element = document.getElementById('section7');
    const bodyRect = document.body.getBoundingClientRect().top;
    const elementRect = element?.getBoundingClientRect().top || 0;
    const elementPosition = elementRect - bodyRect;
    window.scrollTo({
      top: elementPosition,
      behavior: 'smooth'
    });
  }

}





